import React from 'react'

import ExpoSec from '../../components/Demo/ExpoSec'

export default function ExpoSecPage() {
  return <ExpoSec />
}
